import { render, staticRenderFns } from "./SubProductList.vue?vue&type=template&id=1e233071&scoped=true&"
import script from "./SubProductList.vue?vue&type=script&lang=js&"
export * from "./SubProductList.vue?vue&type=script&lang=js&"
import style0 from "./SubProductList.vue?vue&type=style&index=0&id=1e233071&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e233071",
  null
  
)

export default component.exports